const Components = {
    common: {
        name: 'Name',
        description: 'Description',
        title: 'Title'
    },
    header: {
        profile: 'Profile'
    },
    modal: {
        confirmDelete: 'Are you sure you want to delete this item?',
        createLand: 'Add new land',
        editLand: 'Edit land info',
        createAnimal: 'Add new animal',
        editAnimal: 'Edit animal info'
    },
    shareModal: {
        title: 'Share',
        publicProfileButton: 'I want to share my profile',
        privateProfileButton: 'I do not want to share my profile',
        publicProfileInfo:
            'To share the information of the land and its animals, you must make your profile public.',
        publicProfileInfo2:
            'Public profiles allows also other customers to share their lands with you.',
        privateProfileInfo:
            'Private profiles cannot share lands information with other users. Already shared info will not be affected.',
        privateProfileInfo2:
            'Private profiles cannot share lands information with other users.',
        currentReaders: 'Current readers:',
        currentEditors: 'Current editors:',
        addReaders: 'Add readers:',
        addEditors: 'Add editors:',
        reader: 'Readers can see the info of the lands and its animals but not edit it',
        editor: 'Editors can edit the info of the lands and its animals but not delete it',
        owner: 'Owner can see, edit and delete the info of the lands and its animals'
    },
    filters: {
        filters: 'Filters',
        filter: 'Filter',
        clear: 'Clear',
        apply: 'Apply',
        all: 'All',
        typeToSearch: 'Type to search',
        advanced: 'Advanced filters',
        chooseOne: 'Choose one',
        filterById: 'Filter by ID',
        filterByLand: 'Filter by land',
        filterBySpecie: 'Filter by specie',
        filterByGender: 'Filter by gender',
        filterByType: 'Filter by type'
    },
    toast: {
        invalidAccess: 'You do not have access to this resource.',
        userUpdated: 'User updated successfully'
    },
    login: {
        title: 'Access your account',
        login: 'Login',
        logout: 'Logout',
        privacy1: 'By clicking Login, you agree to our',
        privacy2: ' Terms and Conditions',
        resetPassword: 'I need to reset my password',
        noAccount: 'You do not have an account yet?',
        createAccount: 'Create an account'
    },
    register: {
        title: 'Create your account',
        register: 'Register',
        alreadyAccount: 'You already have an account?',
        loginAccount: 'Login your account'
    },
    password: {
        title: 'Recupera tu contraseña',
        emailSent:
            'An email has been sent to your email address, please check your email inbox'
    },
    offline: {
        title: 'It is not possible to connect to internet at this moment.'
    },
    notVerified: {
        title: 'Welcome!',
        text: `Before entering, accounts have to be verified by an administrator.
        Please, wait 24 hours or contact the administrator using the email mifinca2022app@gmail.com to verify your account.`
    },
    analysis: {
        title: 'Analysis'
    },
    users: {
        title: 'Users'
    },
    profile: {
        profile: 'Profile',
        name: 'Name',
        email: 'Email',
        language: 'Language',
        settings: 'Settings',
        english: 'English',
        spanish: 'Español'
    },
    notFound: {
        title: 'Page not found'
    }
};

export default Components;
